import React from 'react';
import { useSelector } from 'react-redux';
import ReportItem from './ReportItem';
import { selectLanguage } from '../../../../store/languageSlice';
import useFetchReportsByEpisode from '../../../../utilFunctions/completedAppointment/useFetchReportsByEpisode';
import CollapsibleWrapper from '../../CollapsibleWrapper';
import Loader from '../../../UI/Loader';

const Reports = () => {
  const { data, loading, error } = useFetchReportsByEpisode();
  const { t, isRtl } = useSelector(selectLanguage);


  const sortReportsByDate = (reports) => {
    return [...reports].sort((a, b) => {
      const dateA = new Date(a.collectedDate);
      const dateB = new Date(b.collectedDate);

      // Handle empty or invalid dates safely
      if (!a.collectedDate) return 1;
      if (!b.collectedDate) return -1;

      return dateA - dateB; // ascending (oldest first)
    });
  };
  let sortedData;
  if (data) {
    sortedData = sortReportsByDate(data);
  }

  return (
    <CollapsibleWrapper title={t.Reports} expand={true}>
      <div className="flex flex-col">
        <ul>
          {sortedData?.map((item, index) => {
            return (
              <li key={index} className="mb-2">
                <ReportItem index={index} report={item} />
              </li>
            );
          })}
        </ul>

        {loading && (
          <div className="w-full justify-center">
            <Loader roundLoader />
          </div>
        )}
        {!loading && data?.length === 0 && (
          <div className="w-full flex justify-center">
            <span className="mt-8">{t.NoRecord}</span>
          </div>
        )}
      </div>
    </CollapsibleWrapper>
  );
};

export default Reports;
